import { IsNotEmpty, IsString } from 'class-validator';

export class TimeProjetoCriarDto {
  @IsString()
  @IsNotEmpty()
  projetoFid: string;
}
